import type { CrmInput, FollowUpInput, OrderInput } from "../types";

export function inputOrders(input: CrmInput): OrderInput[] {
  return input.orders ?? (input.order ? [input.order] : []);
}

export function inputFollowUps(input: CrmInput): FollowUpInput[] {
  return input.follow_ups ?? (input.follow_up ? [input.follow_up] : []);
}
